// mutations_type 雖然是非必要的檔案，主要作為
// action 與 mutation 中間溝通的對應表，這隻檔案的存在，
// 是當系統成長到一定的程度，防止 mutation key 重複，造成不可預期情況發生，也有防呆作用 。

//export 關鍵字，外界才能存取

export const RECODE_TOUCHSCREEN = 'RECODE_TOUCHSCREEN';
export const COUNTDOWNNUM = 'COUNTDOWNNUM';











